<template>
    <!-- keydown.8.stop.prevent="onTabPress" -->
	<v-row class="mt-4 pl-0 ml-n6 mb-n3" style="margin-right: -2px;">
		<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-3 pt-0 pb-0">
			<v-textarea ref="textArea" class="pl-4 pt-3" 
                outlined
                v-model="field.typeProperties.customObjectsTemplate"
                label="Json template structure"
                value="{ }"
            ></v-textarea>
		</v-col>
	</v-row>
	
</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';

export default
{
	name: 'ViewCustomObjectsField',

	props:
	{
		id: { type: String },
		field: { type: Object },
	},

	data: () =>
	({

	}),



	computed:
	{
		agile()
		{
			return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},



	created()
	{
		fb;

	},

	mounted()
	{
		
		// ----------------------------------------------------
		//
		//  When pressing 'tab' in textarea, we want to insert
		//	tab in textarea, not tab to the next component
		//
		// ----------------------------------------------------
		document.addEventListener("keydown", this.onTabPress);

		this.TabManager = {
			tabKey: 9, // This number means tab key ascii input.
			enableTab: function(textBox, keyEvent) {
				if(this.isTabKeyInput(keyEvent)) {
					// Put tab key into the current cursor(caret) position.
					this.insertTab(textBox);
					
					// Block(invalidate) actual tab key input by returning key event handler to false.
					this.blockKeyEvent(keyEvent);   
				}
			},
			isTabKeyInput: function(keyEvent) {
				return keyEvent.keyCode == this.tabKey; 
			},
			insertTab: function(textBox) {
				var pos = this.getCaretPosition(textBox);
				var preText = textBox.value.substring(0, pos);
				var postText = textBox.value.substring(pos, textBox.value.length);

				textBox.value = preText + "\t" + postText; // input tab key

				this.setCaretPosition(textBox, pos + 1);
			},
			setCaretPosition: function(item, pos) {
				// Firefox, Chrome, IE9~ Support
				if(item.setSelectionRange) {
					item.focus();
					item.setSelectionRange(pos, pos);
				}
				// ~IE9 Support
				else if (item.createTextRange) {
					var range = item.createTextRange();
					range.collapse(true);
					range.moveEnd('character', pos);
					range.moveStart('character', pos);
					range.select();
				}
			},
			getCaretPosition: function(item) {
				var caretPosition = 0;
				
				// Firefox, Chrome, IE9~ Support
				if(item.selectionStart || item.selectionStart == '0') {
					caretPosition = item.selectionStart;
				}
				// ~IE9 Support
				else if(document.selection) {
					item.focus();
					var sel = document.selection.createRange();
					sel.moveStart('character', -item.value.length);
					caretPosition = sel.text.length;
				}
				
				return caretPosition;
			},
			blockKeyEvent: function(keyEvent) {
				if(keyEvent.preventDefault) {
					keyEvent.preventDefault();
				}
				else {
					keyEvent.returnValue = false;
				}
			}
		};
	},

	methods:
	{
		onTabPress(e)
		{
			var textBox = this.$refs.textArea.$el.getElementsByTagName('textarea')[0];//document.getElementById('textEditor');
			this.TabManager.enableTab(textBox, e);
		}
	},






	beforeDestroy()
	{
		document.removeEventListener("keydown", this.onTabPress);
	},


}

</script>

